import { render, staticRenderFns } from "./ProvideMobile.vue?vue&type=template&id=62929c2c&scoped=true&"
import script from "./ProvideMobile.vue?vue&type=script&lang=js&"
export * from "./ProvideMobile.vue?vue&type=script&lang=js&"
import style0 from "./ProvideMobile.vue?vue&type=style&index=0&id=62929c2c&lang=scss&scoped=true&"
import style1 from "./ProvideMobile.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62929c2c",
  null
  
)

export default component.exports